import Vue from "vue"
import vuex from "vuex"
import axios from 'axios'
import $ from 'jquery'
import API from '../API'
Vue.use(vuex)

var country = sessionStorage.getItem("country");
var ipinfo =JSON.parse(sessionStorage.getItem("ipinfo"));
var checkoutcurrency=localStorage.getItem("checkoutcurrency");
var rates = sessionStorage.getItem("rates");
rates = rates ? JSON.parse(rates) : {
    [checkoutcurrency]: 1
};
var currentcountry = sessionStorage.getItem("currentcountry");//获取ip所在国家货币
if (!currentcountry) {
    //若ip所在国家货币不存在则点击auto时为结账货币
    currentcountry = checkoutcurrency;
}
//当localStorage里有选过货币并且汇率里面有这个货币的时候才能选用这个货币，否则都为结账货币
console.log('currentcountry',currentcountry);
var pricetype = localStorage.getItem("pricetype") || currentcountry;
pricetype = rates[pricetype] ? pricetype : checkoutcurrency;
var state = {
    ipinfo,//ip信息
    checkoutcurrency,//结账货币
    currentcountry,//用户选择auto时展示的货币
    country,//根据ip获取的国家,地址页使用
    pricetype,//用户选择的货币
    rates,//汇率
    // ratescurrent,
    cartContentsCount: 1,//在购物车页面删除商品时用来使右上角购物车图标的红点消失
    order_shipping: '',//邮费仅在shipping页面选择配送方式时使用
    update_cart: false,//更新购物车的开关，仅在payment页面出现优惠券错误时使用
    news_cart: {},//购物车最新信息,使用优惠券时更新
    cart_type: false,//打开抽屉购物车
    discount_not_enough: "",//优惠券出现不满足的时候
    shipping_insurance_price: '',//运费险价格
    new_comment: {},//新添评论
    feature_image_id: null,//venue主题商品详情页切换图片使用
    now_variant: {},//venue主题商品详情页切换变种使用
    disabled: false,//venue加购按钮使用
}
var mutations = {
    async getipinfo() {
        try {
            let res = await axios.get(API.ipinfo);
            if (res.data) {
                sessionStorage.setItem("ipinfo", JSON.stringify(res.data));
                state.ipinfo= res.data;
            }
            if (res.data && res.data.iso_code) {
                console.log('state.country',res.data.iso_code);
                sessionStorage.setItem("country", res.data.iso_code);
                state.country= res.data.iso_code;
                console.log('state.country',state);
            }
            if (res.data && res.data.currency) {
                sessionStorage.setItem("currentcountry", res.data.currency);
                state.currentcountry=  state.rates[res.data.currency]?res.data.currency:checkoutcurrency;
                state.pricetype=  state.rates[res.data.currency]?res.data.currency:checkoutcurrency;
            }
        } catch (error) {
            state.currentcountry= checkoutcurrency;
            state.pricetype= checkoutcurrency;
        }
    },
    change_new_comment(state, new_comment) {
        state.new_comment = new_comment;
    },
    change_shipping_insurance_price(state, shipping_insurance_price) {
        state.shipping_insurance_price = shipping_insurance_price;
    },
    change_discount_not_enough(state, discount_not_enough) {
        state.discount_not_enough = discount_not_enough;
    },
    change_cart_type(state, cart_type) {
        state.cart_type = cart_type;
    },
    change_news_cart(state, news_cart) {
        state.news_cart = news_cart;
    },
    change_update_cart(state, onOff) {
        state.update_cart = onOff;
    },
    change_order_shipping(state, price) {
        state.order_shipping = price;
    },
    changepricetype(state, type) {
        state.pricetype = type
    },
    async getrates(state) {
        state.rates = {
            [checkoutcurrency]: 1
        }
        state.currentcountry= checkoutcurrency;
        state.pricetype= checkoutcurrency;
        try {
            state.pricetype = checkoutcurrency;
            let res = await axios.get(API.exchanges)
            //获取汇率
            sessionStorage.setItem("rates", JSON.stringify(res.data.rates))
            sessionStorage.setItem("rates_base", res.data.base)
            state.rates = res.data.rates;
            state.pricetype =  sessionStorage.getItem("currentcountry");
            state.currentcountry=  sessionStorage.getItem("currentcountry");
        } catch (error) {
            console.log(error);
        }
    },
    cartContentsCount(state, count) {
        state.cartContentsCount = count
    },
    change_feature_image_id(state, new_id) {
        state.feature_image_id = new_id
    },
    change_now_variant(state, now_variant) {
        state.now_variant = now_variant
    },
    change_button_disabled(state, button_disabled) {
        state.disabled = button_disabled
    },


}
var actions = {
    change_new_comment(context, new_comment) {
        context.commit("change_new_comment", new_comment)
    },
    change_shipping_insurance_price(context, shipping_insurance_price) {
        context.commit("change_shipping_insurance_price", shipping_insurance_price)
    },
    change_discount_not_enough(context, discount_not_enough) {
        context.commit("change_discount_not_enough", discount_not_enough)
    },
    change_cart_type(context, cart_type) {
        context.commit("change_cart_type", cart_type)
    },
    change_news_cart(context, news_cart) {
        context.commit("change_news_cart", news_cart)
    },
    change_update_cart(context, onOff) {
        context.commit("change_update_cart", onOff)
    },
    change_order_shipping(context, price) {
        context.commit("change_order_shipping", price)
    },
    changepricetype(context, type) {
        context.commit("changepricetype", type)
    },
    cartContentsCount(context, count) {
        context.commit("cartContentsCount", count)
    },
    change_feature_image_id(context, new_id) {
        context.commit("change_feature_image_id", new_id)
    },
    change_now_variant(context, now_variant) {
        context.commit("change_now_variant", now_variant)
    },
    change_button_disabled(context, button_disabled) {
        context.commit("change_button_disabled", button_disabled)
    }
}
var store = new vuex.Store({
    state,
    mutations,
    actions,
})

if (!sessionStorage.getItem("rates") || checkoutcurrency !== sessionStorage.getItem("rates_base")) {
    
    store.commit("getrates");
}

if (!sessionStorage.getItem("ipinfo") ||!sessionStorage.getItem("currentcountry") || !sessionStorage.getItem("country")) {
    store.commit("getipinfo");
}

export default store